import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import propTypes from 'prop-types';
import styled from 'styled-components';
import Tooltip from '@mui/material/Tooltip';
import ErrorIcon from '@material-ui/icons/Error';
import Autocomplete from '@mui/material/Autocomplete';
import axios from 'axios';
import Skeleton from '@mui/material/Skeleton';
import { StyledButton } from '../../../../Components/Generics.styled';
import { useAdvertisers } from '../../../../Contexts/AdvertisersContext';
const AdCampaignInfoContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    flex-direction: column;
`;

const Title = styled.div`
    margin-top: 100px;
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    font-weight: bold;
    text-align: center;
`;

const GoogleAdInfo = styled.div`
    padding: 16px;
    max-width: 1200px;
    width: 100%;
    align-items: center;
    column-gap: 50px;
    display: flex;
    flex-direction: row;
    margin-bottom: 50px;

    @media only screen and (max-width: 500px) {
        flex-direction: column;
    }
`;

const Column1 = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;
const Column2 = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

const TextFieldContainer = styled.div`
    height: 100px;
    margin-bottom: 40px;

    .pontiac-field {
        width: 100%;
        min-width: 400px;
    }
`;

const SelectorContainer = styled.div`
    height: 100%;
`;

const StyledNavButtons = styled.div`
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const StyledTextField = styled(TextField)`
    width: 100%;

    .MuiOutlinedInput-root {
        background-color: #fafbf7;
    }
`;

const StyledHelpText = styled.div`
    font-size: 12px;
    width: 100%;
    word-wrap: break-word;
`;

const StyledHelpTextInfo = styled.span`
    letter-spacing: 0px;
    color: #868d96;
    opacity: 1;
    padding-right: 8px;
`;

const PontiacAdInfoContainer = styled.div`
    display: flex;
`;

const AdCampaignInfo = (props) => {
    const { campaignData, setCampaignData, handleNavButtonBack, handleNavButtonNext, setPageIndex } = props;

    const isGoogle = campaignData?.campaignTypeId === 1;
    const isProgrammatic = campaignData?.campaignTypeId === 26;
    const isMobile = campaignData?.campaignTypeId === 2;

    const { advertiserMetaData } = useAdvertisers();
    const { selectedAdvertiserTeachData } = { ...advertiserMetaData };

    const [keywordVals, setKeywordVals] = useState([]);
    const [keywordsTooLong, setKeywordsTooLong] = useState(false);

    const [chatGPTData, setChatGPTData] = useState({});
    const [gptPostData, setGPTPostData] = useState({
        isLoading: false,
        error: false,
        success: false,
        message: [''],
    });

    const calculate = () => {
        fetchTheData();
    };

    const fetchTheData = async () => {
        try {
            setGPTPostData({ ...gptPostData, isLoading: true });
            const chatGPTResp = await axios({
                method: 'post',
                url: `${process.env.REACT_APP_API_BASE_URL}/generateAdCampaignInfo`,
                headers: {
                    'Content-Type': 'application/json',
                },
                data: {
                    campaignData,
                    selectedAdvertiserTeachData,
                },
            });

            const campaignInfo = chatGPTResp?.data;
            if (campaignInfo && campaignInfo.campaignName && campaignInfo.headline) {
                setChatGPTData(campaignInfo);

                setGPTPostData({
                    isLoading: false,
                    success: true,
                    error: false,
                    message: ['Succesful'],
                });
            } else {
                console.error('Invalid response structure:', campaignInfo);
                setGPTPostData({
                    isLoading: false,
                    success: false,
                    error: true,
                    message: ['Invalid response from server'],
                });
            }
        } catch (err) {
            setGPTPostData({
                isLoading: false,
                success: false,
                error: true,
                message: ['Something went wrong'],
            });
        }
    };

    useEffect(() => {
        if (gptPostData.success && chatGPTData.campaignName) {
            setCampaignData({
                ...campaignData,
                campaignName: chatGPTData?.campaignName,
                description: chatGPTData?.description,
                description2: chatGPTData?.description2,
                description3: chatGPTData?.description3,
                description4: chatGPTData?.description4,
                description5: chatGPTData?.description5,
                googleCampaignKeywords: chatGPTData?.googleCampaignKeywords,
                headline: chatGPTData?.headline,
                headline2: chatGPTData?.headline2,
                headline3: chatGPTData?.headline3,
                headline4: chatGPTData?.headline4,
                headline5: chatGPTData?.headline5,
                headline6: chatGPTData?.headline6,
            });
        }
    }, [chatGPTData, gptPostData]);

    useEffect(() => {
        campaignData?.googleCampaignKeywords.map((item) => {
            if (item.length > 25) {
                setKeywordsTooLong(true);
            } else {
                setKeywordsTooLong(false);
            }
        });
    }, [campaignData.googleCampaignKeywords]);

    const handleKeywords = (e) => {
        setKeywordVals([e.target.value]);
    };

    const determineBackRoute = () => {
        if (!isGoogle) {
            handleNavButtonBack();
        } else {
            setPageIndex(4);
        }
    };
    const HelpText = (props) => {
        const { text, toolTip, style } = props;
        return (
            <StyledHelpText style={style}>
                <StyledHelpTextInfo>{text}</StyledHelpTextInfo>
                <Tooltip title={toolTip}>
                    <ErrorIcon />
                </Tooltip>
            </StyledHelpText>
        );
    };

    const headlineSame =
        campaignData.headline === campaignData.headline2 ||
        campaignData.headline === campaignData.headline3 ||
        campaignData.headline === campaignData.headline4 ||
        campaignData.headline === campaignData.headline5 ||
        campaignData.headline === campaignData.headline6;

    const headline2Same =
        campaignData.headline2 === campaignData.headline ||
        campaignData.headline2 === campaignData.headline3 ||
        campaignData.headline2 === campaignData.headline4 ||
        campaignData.headline2 === campaignData.headline5 ||
        campaignData.headline2 === campaignData.headline6;

    const headline3Same =
        campaignData.headline3 === campaignData.headline ||
        campaignData.headline3 === campaignData.headline2 ||
        campaignData.headline3 === campaignData.headline4 ||
        campaignData.headline3 === campaignData.headline5 ||
        campaignData.headline3 === campaignData.headline6;

    const headline4Same =
        campaignData.headline4 === campaignData.headline ||
        campaignData.headline4 === campaignData.headline2 ||
        campaignData.headline4 === campaignData.headline3 ||
        campaignData.headline4 === campaignData.headline5 ||
        campaignData.headline4 === campaignData.headline6;

    const headline5Same =
        campaignData.headline5 === campaignData.headline ||
        campaignData.headline5 === campaignData.headline2 ||
        campaignData.headline5 === campaignData.headline3 ||
        campaignData.headline5 === campaignData.headline4 ||
        campaignData.headline5 === campaignData.headline6;

    const headline6Same =
        campaignData.headline6 === campaignData.headline ||
        campaignData.headline6 === campaignData.headline2 ||
        campaignData.headline6 === campaignData.headline3 ||
        campaignData.headline6 === campaignData.headline4 ||
        campaignData.headline6 === campaignData.headline5;

    const descriptionSame =
        campaignData.description === campaignData.description2 ||
        campaignData.description === campaignData.description3 ||
        campaignData.description === campaignData.description4;

    const description2Same =
        campaignData.description2 === campaignData.description3 ||
        campaignData.description2 === campaignData.description4 ||
        campaignData.description2 === campaignData.description;

    const description3Same =
        campaignData.description3 === campaignData.description4 ||
        campaignData.description3 === campaignData.description ||
        campaignData.description3 === campaignData.description2;

    const description4Same =
        campaignData.description4 === campaignData.description ||
        campaignData.description4 === campaignData.description2 ||
        campaignData.description4 === campaignData.description3;

    const nextButtonIsDisabled =
        (isMobile &&
            (campaignData?.campaignName === '' ||
                campaignData?.headline === '' ||
                campaignData?.headline?.length > 30 ||
                campaignData?.productDescription === '' ||
                campaignData?.productDescription?.length > 30 ||
                campaignData?.redemptionInstructions === '' ||
                campaignData?.redemptionInstructions?.length > 30 ||
                campaignData?.brandName === '' ||
                campaignData?.brandName.length > 90 ||
                campaignData?.offerDescription === '' ||
                campaignData?.offerDescription.length > 90)) ||
        (isGoogle &&
            (campaignData?.campaignName === '' ||
                campaignData?.campaignName.length > 25 ||
                campaignData?.headline === '' ||
                campaignData?.headline?.length < 3 ||
                campaignData?.headline?.length > 30 ||
                headlineSame ||
                campaignData?.headline2 === '' ||
                campaignData?.headline2?.length < 3 ||
                campaignData?.headline2?.length > 30 ||
                headline2Same ||
                campaignData?.headline3 === '' ||
                campaignData?.headline3?.length < 3 ||
                campaignData?.headline3?.length > 30 ||
                headline3Same ||
                campaignData?.headline4?.length > 30 ||
                (headline4Same && campaignData?.headline4 !== '') ||
                campaignData?.headline5?.length > 30 ||
                (headline5Same && campaignData?.headline5 !== '') ||
                campaignData?.headline6?.length > 30 ||
                (headline6Same && campaignData?.headline6 !== '') ||
                campaignData?.description === '' ||
                campaignData?.description?.length > 90 ||
                campaignData?.description?.length < 3 ||
                descriptionSame ||
                campaignData?.description2 === '' ||
                campaignData?.description2?.length > 90 ||
                campaignData?.description2?.length < 3 ||
                description2Same ||
                campaignData?.description3?.length > 90 ||
                (campaignData?.description3 !== '' && description3Same) ||
                campaignData?.description4?.length > 90 ||
                campaignData?.googleCampaignKeywords?.length < 1 ||
                keywordsTooLong ||
                (campaignData?.description4 !== '' && description4Same))) ||
        (isProgrammatic && (campaignData?.campaignName === '' || campaignData?.campaignName?.length > 25));

    HelpText.propTypes = {
        text: propTypes.string,
        toolTip: propTypes.string,
        style: propTypes.shape({}),
    };

    HelpText.defaultProps = {
        text: '',
        toolTip: '',
        style: {},
    };

    const pontiacAdInfo = isProgrammatic && (
        <>
            <PontiacAdInfoContainer>
                <TextFieldContainer>
                    <StyledTextField
                        className="pontiac-field"
                        id="campaign-name"
                        label="Campaign Name"
                        value={campaignData?.campaignName}
                        onChange={(e) =>
                            setCampaignData({
                                ...campaignData,
                                campaignName: e.target.value,
                            })
                        }
                        variant="outlined"
                        error={campaignData.campaignName === '' || campaignData.campaignName.length > 25 || campaignData.campaignName.length < 3}
                        helperText={
                            campaignData.campaignName.length > 25 || campaignData.campaignName.length < 3
                                ? 'Must be greater than 3 characters and less than 25'
                                : ''
                        }
                    />

                    <HelpText
                        text="(Character limit 25)"
                        toolTip="Enter a Unique Name for your Campaign – Make sure it’s a name you’ll remember and one that will distinguish it from other similar campaigns.   Here’s an example “November 2021, Display, Kid’s Games BOGO”"
                    />
                </TextFieldContainer>
            </PontiacAdInfoContainer>
        </>
    );

    const googleAdInfo = isGoogle && (
        <>
            <GoogleAdInfo>
                <Column1>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="campaign-name"
                                label="Campaign Name"
                                value={campaignData?.campaignName}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        campaignName: e.target.value,
                                    })
                                }
                                variant="outlined"
                                error={
                                    campaignData.campaignName === '' || campaignData.campaignName.length > 25 || campaignData.campaignName.length < 3
                                }
                                helperText={
                                    campaignData.campaignName.length > 25 || campaignData.campaignName.length < 3
                                        ? 'Must be greater than 3 characters and less than 25'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 25)"
                            toolTip="Enter a Unique Name for your Campaign – Make sure it’s a name you’ll remember and one that will distinguish it from other similar campaigns.   Here’s an example “November 2021, Display, Kid’s Games BOGO”"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="description"
                                label="Description"
                                value={campaignData.description}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        description: e.target.value,
                                    })
                                }
                                multiline
                                variant="outlined"
                                error={
                                    campaignData.description === '' ||
                                    campaignData.description.length > 90 ||
                                    campaignData.description.length < 3 ||
                                    descriptionSame
                                }
                                helperText={
                                    campaignData.description.length > 90 || campaignData.description.length < 3 || descriptionSame
                                        ? 'Must be unique and greater than 3 characters and less than 90 characters'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 90)"
                            toolTip="Enter a Description that will explain what you’re promoting.  Here’s an example:   “The Best Toys are Toys that Teach – See the best selection of our Play to Learn toys.  Click Here”"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="description-2"
                                label="Description 2"
                                value={campaignData.description2}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        description2: e.target.value,
                                    })
                                }
                                multiline
                                variant="outlined"
                                error={
                                    campaignData.description2 === '' ||
                                    campaignData.description2.length > 90 ||
                                    campaignData.description2.length < 3 ||
                                    description2Same
                                }
                                helperText={
                                    campaignData.description2.length > 90 || campaignData.description2.length < 3 || description2Same
                                        ? 'Must be greater than 3 characters and less than 90 characters'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 90)"
                            toolTip="Enter a brief description of your offer that may appear on a coupon, text message, or as the search engine description of your offering:  Here’s an Example: “Toys that Teach – Buy One Get One’"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="description-3"
                                label="Description 3"
                                value={campaignData.description3}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        description3: e.target.value,
                                    })
                                }
                                multiline
                                variant="outlined"
                                error={
                                    campaignData.description3 === '' ||
                                    campaignData.description3.length > 90 ||
                                    campaignData.description3.length < 3 ||
                                    description3Same
                                }
                                helperText={
                                    campaignData.description3.length > 90 || campaignData.description3.length < 3 || description3Same
                                        ? 'Must be greater than 3 characters and less than 90 characters'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 90)"
                            toolTip="Enter a brief description of your offer that may appear on a coupon, text message, or as the search engine description of your offering:  Here’s an Example: “Toys that Teach – Buy One Get One’"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="description-4"
                                label="Description 4"
                                value={campaignData.description4}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        description4: e.target.value,
                                    })
                                }
                                multiline
                                variant="outlined"
                                error={
                                    campaignData.description4 === '' ||
                                    campaignData.description4.length > 90 ||
                                    campaignData.description4.length < 4 ||
                                    description4Same
                                }
                                helperText={
                                    campaignData.description4.length > 90 || campaignData.description4.length < 4 || description4Same
                                        ? 'Must be greater than 3 characters and less than 90 characters'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 90)"
                            toolTip="Enter a brief description of your offer that may appear on a coupon, text message, or as the search engine description of your offering:  Here’s an Example: “Toys that Teach – Buy One Get One’"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        <SelectorContainer>
                            {gptPostData.isLoading ? (
                                <Skeleton height={60} />
                            ) : (
                                <Autocomplete
                                    multiple
                                    id="keywords"
                                    options={keywordVals}
                                    value={campaignData.googleCampaignKeywords || []}
                                    getOptionLabel={(option) => option}
                                    onChange={(e, value) =>
                                        setCampaignData({
                                            ...campaignData,
                                            googleCampaignKeywords: value,
                                        })
                                    }
                                    renderInput={(params) => (
                                        <StyledTextField
                                            onChange={(e) => handleKeywords(e)}
                                            variant="outlined"
                                            {...params}
                                            label="Keywords"
                                            placeholder="Add or remove keywords"
                                            error={campaignData.googleCampaignKeywords.length < 1 || keywordsTooLong}
                                            helperText={
                                                keywordsTooLong || campaignData.googleCampaignKeywords.length < 1
                                                    ? 'You must select at least one keyword, and keywords must be below 25 characters.'
                                                    : ''
                                            }
                                        />
                                    )}
                                />
                            )}
                        </SelectorContainer>
                        <HelpText
                            text="(Character limit 25)"
                            toolTip="What are the words that best describe your offer, for search engines or other context focused web sites?   Examples would be “Toys”, Teaching Toys, Educational Toys, Best Toys for Learning”.  You can enter the brands of the products you’re offering as well. Enter as many as keywords as make sense for you.  After you type, click on the keyword displayed and then you can enter another.    When your done click on the next button."
                        />
                    </TextFieldContainer>
                </Column1>
                <Column2>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="headline"
                                label="Headline"
                                value={campaignData.headline}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        headline: e.target.value,
                                    })
                                }
                                variant="outlined"
                                error={
                                    campaignData.headline === '' ||
                                    campaignData.headline.length > 30 ||
                                    campaignData.headline.length < 3 ||
                                    headlineSame
                                }
                                helperText={
                                    campaignData.headline.length > 30 || campaignData.headline.length < 3 || headlineSame
                                        ? 'Must be unique, greater than 3 characters and less than 30'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 30)"
                            toolTip="Enter a Brief Headline that may appear in your ad, but will catch the viewer’s eye.  Here’s an example:   ” BOGO Teaching Toys for Kids”"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="headline-2"
                                label="Headline 2"
                                value={campaignData.headline2}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        headline2: e.target.value,
                                    })
                                }
                                variant="outlined"
                                error={
                                    campaignData.headline2 === '' ||
                                    campaignData.headline2.length > 30 ||
                                    campaignData.headline2.length < 3 ||
                                    headline2Same
                                }
                                helperText={
                                    campaignData.headline2.length > 30 || campaignData.headline2.length < 3 || headline2Same
                                        ? 'Must be unique, greater than 3 characters and less than 30 characters.'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 30)"
                            toolTip="Enter your brand or the brand of the what you’re offering.  Here’s an example:   “Play to Learn”"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="headline-3"
                                label="Headline 3"
                                value={campaignData.headline3}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        headline3: e.target.value,
                                    })
                                }
                                variant="outlined"
                                error={
                                    campaignData.headline3 === '' ||
                                    campaignData.headline3.length > 30 ||
                                    campaignData.headline3.length < 3 ||
                                    headline3Same
                                }
                                helperText={
                                    campaignData.headline3.length > 30 || campaignData.headline3.length < 3 || headline3Same
                                        ? 'Must be unique, greater than 3 characters and less than 30 characters'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 30)"
                            toolTip="Enter a Brief Headline that may appear in your ad, but will catch the viewer’s eye.  Here’s an example:   ” BOGO Teaching Toys for Kids”"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="headline-4"
                                label="Headline 4"
                                value={campaignData.headline4}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        headline4: e.target.value,
                                    })
                                }
                                variant="outlined"
                                error={campaignData.headline4.length > 30 || (campaignData.headline4 !== '' && headline4Same)}
                                helperText={
                                    campaignData.headline4.length > 30 || (campaignData.headline4 !== '' && headline4Same)
                                        ? 'Must be unique and less than 30 characters'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 30)"
                            toolTip="Enter a Brief Headline that may appear in your ad, but will catch the viewer’s eye.  Here’s an example:   ” BOGO Teaching Toys for Kids”"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="headline-5"
                                label="Headline 5"
                                value={campaignData.headline5}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        headline5: e.target.value,
                                    })
                                }
                                variant="outlined"
                                error={campaignData.headline5.length > 30 || (campaignData.headline5 !== '' && headline5Same)}
                                helperText={
                                    campaignData.headline5.length > 30 || (campaignData.headline5 !== '' && headline5Same)
                                        ? 'Must be unique and less than 30 characters'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 30)"
                            toolTip="Enter a Brief Headline that may appear in your ad, but will catch the viewer’s eye.  Here’s an example:   ” BOGO Teaching Toys for Kids”"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="headline-6"
                                label="Headline 6"
                                value={campaignData.headline6}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        headline6: e.target.value,
                                    })
                                }
                                variant="outlined"
                                error={campaignData.headline6.length > 30 || (campaignData.headline6 !== '' && headline6Same)}
                                helperText={
                                    campaignData.headline6.length > 30 || (campaignData.headline6 !== '' && headline6Same)
                                        ? 'Must be unique and less than 30 characters'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 30)"
                            toolTip="Enter a Brief Headline that may appear in your ad, but will catch the viewer’s eye.  Here’s an example:   ” BOGO Teaching Toys for Kids”"
                        />
                    </TextFieldContainer>
                </Column2>
            </GoogleAdInfo>
        </>
    );

    const mobileAdInfo = isMobile && (
        <>
            <GoogleAdInfo>
                <Column1>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="campaign-name"
                                label="Campaign Name"
                                value={campaignData?.campaignName}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        campaignName: e.target.value,
                                    })
                                }
                                variant="outlined"
                                error={
                                    campaignData.campaignName === '' ||
                                    campaignData.campaignName?.length > 25 ||
                                    campaignData.campaignName?.length < 3
                                }
                                helperText={
                                    campaignData.campaignName?.length > 25 || campaignData.campaignName?.length < 3
                                        ? 'Must be greater than 3 characters and less than 25'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 25)"
                            toolTip="Enter a Unique Name for your Campaign – Make sure it’s a name you’ll remember and one that will distinguish it from other similar campaigns.   Here’s an example “November 2021, Display, Kid’s Games BOGO”"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="brand-name"
                                label="Brand Name"
                                value={campaignData.brandName}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        brandName: e.target.value,
                                    })
                                }
                                multiline
                                variant="outlined"
                                error={campaignData.brandName === '' || campaignData.brandName?.length > 90 || campaignData.brandName?.length < 3}
                                helperText={
                                    campaignData.brandName?.length > 90 || campaignData.brandName?.length < 3
                                        ? 'Must greater than 3 characters and less than 90'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 90)"
                            toolTip="Enter a brand name that will explain what you’re promoting.  Here’s an example:   “The Best Toys are Toys that Teach – See the best selection of our Play to Learn toys.  Click Here”"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="offer-description"
                                label="Offer Description"
                                value={campaignData.offerDescription}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        offerDescription: e.target.value,
                                    })
                                }
                                multiline
                                variant="outlined"
                                error={
                                    campaignData.offerDescription === '' ||
                                    campaignData.offerDescription?.length > 90 ||
                                    campaignData.offerDescription?.length < 3
                                }
                                helperText={
                                    campaignData.offerDescription?.length > 90 || campaignData.offerDescription?.length < 3
                                        ? 'Must be greater than 3 characters and less than 90 characters'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 90)"
                            toolTip="Enter a brief description of your offer that may appear on a coupon, text message, or as the search engine description of your offering:  Here’s an Example: “Toys that Teach – Buy One Get One’"
                        />
                    </TextFieldContainer>
                </Column1>
                <Column2>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="headline"
                                label="Headline"
                                value={campaignData.headline}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        headline: e.target.value,
                                    })
                                }
                                variant="outlined"
                                error={campaignData.headline === '' || campaignData.headline?.length > 30 || campaignData.headline?.length < 3}
                                helperText={
                                    campaignData.headline?.length > 30 || campaignData.headline?.length < 3
                                        ? 'Must be greater than 3 characters and less than 30'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 30)"
                            toolTip="Enter a Brief Headline that may appear in your ad, but will catch the viewer’s eye.  Here’s an example:   ” BOGO Teaching Toys for Kids”"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="descpription"
                                label="Description"
                                value={campaignData.productDescription}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        productDescription: e.target.value,
                                    })
                                }
                                variant="outlined"
                                error={
                                    campaignData.productDescription === '' ||
                                    campaignData.productDescription?.length > 30 ||
                                    campaignData.productDescription?.length < 3
                                }
                                helperText={
                                    campaignData.productDescription?.length > 30 || campaignData.productDescription?.length < 3
                                        ? 'Must be greater than 3 characters and less than 30 characters.'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 30)"
                            toolTip="Enter your brand or the brand of the what you’re offering.  Here’s an example:   “Play to Learn”"
                        />
                    </TextFieldContainer>
                    <TextFieldContainer>
                        {gptPostData.isLoading ? (
                            <Skeleton height={60} />
                        ) : (
                            <StyledTextField
                                id="redemption-instructions"
                                label="Redemption Instructions"
                                value={campaignData.redemptionInstructions}
                                onChange={(e) =>
                                    setCampaignData({
                                        ...campaignData,
                                        redemptionInstructions: e.target.value,
                                    })
                                }
                                variant="outlined"
                                error={
                                    campaignData.redemptionInstructions === '' ||
                                    campaignData.redemptionInstructions?.length > 30 ||
                                    campaignData.redemptionInstructions?.length < 3
                                }
                                helperText={
                                    campaignData.redemptionInstructions?.length > 30 || campaignData.redemptionInstructions?.length < 3
                                        ? 'Must be greater than 3 characters and less than 30 characters'
                                        : ''
                                }
                            />
                        )}
                        <HelpText
                            text="(Character limit 30)"
                            toolTip="Enter a Brief Headline that may appear in your ad, but will catch the viewer’s eye.  Here’s an example:   ” BOGO Teaching Toys for Kids”"
                        />
                    </TextFieldContainer>
                </Column2>
            </GoogleAdInfo>
        </>
    );

    return (
        <AdCampaignInfoContainer>
            <Title>Campaign Information</Title>
            {isGoogle || isMobile ? (
                <>
                    {!isMobile ? (
                        <StyledButton variant="contained" color="primary" onClick={() => calculate()}>
                            Generate new suggestions
                        </StyledButton>
                    ) : null}

                    <div style={{ marginTop: '20px' }}>
                        {gptPostData.isLoading ? 'Please wait... We are using davie.ai to generate suggestions for your ad.' : null}
                    </div>
                </>
            ) : null}

            {googleAdInfo}
            {pontiacAdInfo}
            {mobileAdInfo}
            <StyledNavButtons>
                <StyledButton variant="contained" color="primary" onClick={() => determineBackRoute()}>
                    Back
                </StyledButton>
                <StyledButton variant="contained" color="primary" onClick={() => handleNavButtonNext()} disabled={nextButtonIsDisabled}>
                    Next
                </StyledButton>
            </StyledNavButtons>
        </AdCampaignInfoContainer>
    );
};

AdCampaignInfo.propTypes = {
    campaignData: propTypes.shape({
        campaignTypeName: propTypes.string,
        campaignTypeCategoryName: propTypes.string,
        campaignName: propTypes.string,
        campaignTypeId: propTypes.number,
        headline: propTypes.string,
        headline2: propTypes.string,
        headline3: propTypes.string,
        headline4: propTypes.string,
        headline5: propTypes.string,
        headline6: propTypes.string,
        advertiserName: propTypes.string,
        brandName: propTypes.string,
        productDescription: propTypes.string,
        redemptionInstructions: propTypes.string,
        offerDescription: propTypes.string,
        websiteURL: propTypes.string,
        description: propTypes.string,
        description2: propTypes.string,
        description3: propTypes.string,
        description4: propTypes.string,
        locations: propTypes.array,
        startDate: propTypes.string,
        endDate: propTypes.string,
        campaignType: propTypes.string,
        googleCampaignKeywords: propTypes.arrayOf(propTypes.string),
    }),
    setCampaignData: propTypes.func,
    handleNavButtonNext: propTypes.func,
    handleNavButtonBack: propTypes.func,
    setPageIndex: propTypes.func,
};

AdCampaignInfo.defaultProps = {
    campaignData: {},
    setCampaignData: () => {},
    handleNavButtonNext: () => {},
    handleNavButtonBack: () => {},
    setPageIndex: () => {},
};
export default AdCampaignInfo;
